import { render, staticRenderFns } from "./SendTips.vue?vue&type=template&id=f245e78a&"
import script from "./SendTips.vue?vue&type=script&lang=js&"
export * from "./SendTips.vue?vue&type=script&lang=js&"
import style0 from "./SendTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports